<div class="show-location">
  <div class="show-location-search">
    <input
      id="location-input"
      class="search-btn"
      placeholder="Search location..."
      #locationAutocompleteText
      value=""
      (input)="inputLocation(locationAutocompleteText)"
      />
      @if (locationSearchValue) {
        <div
          mat-button
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="clearViewState()"
          class="search-btn-delete"
        ></div>
      }
      <div class="show-location-search-view-cancel" (click)="toggleCancelView()">
        <span>Cancel</span>
      </div>
      <div [ngClass]="showPlacesDropdown ? 'show-location-dropdown' : 'show-location-dropdown-hide'">
        <div class="show-location-dropdown-content">
          @for (location of locationsData; track location) {
            <div
              class="show-location-dropdown-item"
              (click)="addMapLocation(location)"
              >
              <img class="show-location-dropdown-item-img" src="../../../../../../assets/svg/location-dropdown-icon.svg">
              <div class="show-location-dropdown-item-content">
                <div class="show-location-dropdown-item-content-main">{{location.mainAddress}}</div>
                <div class="show-location-dropdown-item-content-secondary">{{location.secondaryAddress}}</div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>

    <div #locationMap class="show-location-map-view"></div>
  </div>

  <div
    #infoWindowContent
    class="info-window-content"
    >
    <p>{{ locationMessage.locationAddress }}</p>
    @if (locationMessage?.locationAddress) {
      <div id="share-location" class="share-location" (click)="shareLocation()">{{text}} Location</div>
    }
  </div>
